import getApiClient from 'src/utils/getApiClient'
import type { LpuScheduleResponse } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/api/apiLpuSchedule.types'

const apiClient = getApiClient()

const apiLpuSchedule = {
  get(addressId: number) {
    return apiClient.get<LpuScheduleResponse>('/ajax/schedule/', {
      params: {
        address: addressId,
      },
    })
  },
}

export default apiLpuSchedule
